<template>
    <div>
        <h1 class="font-weight-bold">Services</h1>
        <div>
            <b-row class="mt-3">
                <b-col>
                    <b-form-group label="" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="btn-radios-2"
                            v-model="isCompleted"
                            :options="completedStates"
                            :aria-describedby="ariaDescribedby"
                            button-variant="outline-primary"
                            name="radio-btn-outline"
                            buttons
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col class="text-right">
                    <b-button
                        @click="showFilter = !showFilter"
                        variant="outline-secondary"
                        class="px-3"
                    >
                        <b-icon-filter variant="outline-secondary" class="mr-2">
                        </b-icon-filter>
                        Filter By
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <service-filter v-model="filters" v-show="showFilter" />
            </b-row>
        </div>

        <hr />
        <b-row class="justify-content-md-center">
            <b-col>
                {{ `Page ${currentPage} of ${Math.ceil(rows / perPage)}` }}
            </b-col>
            <b-col>
                <b-form-group
                    id="fieldset-perPage"
                    label="Items Per Page:"
                    label-for="input-perPage"
                    label-cols="6"
                >
                    <b-select
                        id="input-perPage"
                        v-model="perPage"
                        :options="[3, 5, 10, 20]"
                    ></b-select>
                </b-form-group>
            </b-col>
            <b-col>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-col>
        </b-row>
        <b-row>
            <b-card-body>
                <b-table :fields="fields" :items="orders">
                    <template #cell(id)="row">
                        <b-button
                            size="sm"
                            @click="gotoDetails(row.item.id)"
                            class="mr-2"
                            variant="primary"
                        >
                            View
                        </b-button>
                    </template>
                </b-table>
            </b-card-body>
        </b-row>
    </div>
</template>
<script>
// import ServiceSummary from './ServiceSummary'
import ServiceFilter from './ServiceFilter'
// import ItemIterator from './ItemIterator'

const currentTime = Date.now()
const dayTime = 24 * 60 * 60 * 1000

const created_end = new Date(currentTime + 15 * dayTime)
    .toISOString()
    .split('T')[0]
const created_start = new Date(currentTime - 15 * dayTime)
    .toISOString()
    .split('T')[0]

export default {
    name: 'CustomerPortalServiceRequests',
    components: {
        // ServiceSummary,
        ServiceFilter,
        // ItemIterator,
    },
    data() {
        return {
            perPage: 3,
            currentPage: 1,
            openOrders: true,
            showFilter: false,
            isCompleted: 0,
            completedStates: [
                { text: 'Active', value: 0 },
                { text: 'Closed', value: 1 },
            ],
            filters: {
                // Set Initial values
                order_type_id: 0,
                service_category: 0,
                created_start,
                created_end,
            },
            fields: [
                { label: 'Actions', key: 'id' },
                {
                    key: 'reference_no',
                    label: 'Reference No',
                },
                {
                    key: 'order_type',
                    label: 'Activity Type',
                    formatter: (value, key, order) =>
                        order.type.customer_portal_name || order.type.name,
                },
                {
                    key: 'service_category',
                    label: 'Activity Category',
                    formatter: (value, key, order) =>
                        order.category.customer_portal_name ||
                        order.category.name,
                },
                {
                    key: 'description',
                    label: 'Description',
                },
                {
                    key: 'created_at',
                    label: 'Created On',
                    formatter: (value, key, item) =>
                        item.created_at.split(' ')[0],
                },
                {
                    key: 'completed_by',
                    label: 'Completed On',
                    formatter: (value, key, item) => {
                        if (item.completed_at) {
                            return item.completed_at.split(' ')[0]
                        } else {
                            return ''
                        }
                    },
                },
                {
                    key: 'driver_id',
                    label: 'Officer',
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'total_price',
                    label: 'Price',
                    formatter: (value, key, item) => {
                        return `$${this.calculateOrderPrice(item)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
                    },
                },
            ],
        }
    },

    computed: {
        rows() {
            return this.orders.length
        },
        orders() {
            const orders = this.$store.state.customerPortal.orders
            console.log('order ---', orders)
            return orders.filter(order => {
                return (
                    this.filterOrderTypes(order) &&
                    this.filterRequestCategories(order) &&
                    this.filterDateRange(order) &&
                    this.filterCompleted(order)
                )
            })
        },
    },

    mounted() {
        this.$store.dispatch('customerPortal/fetchOrders')
    },

    watch: {
        filters: {
            handler: function () {},
            deep: true,
        },
    },
    filters: {},
    methods: {
        toggleOpenOrders() {
            this.openOrders = !this.openOrders
        },
        gotoDetails(id) {
            this.$router.push(`/customer-portal/view-service/${id}`)
        },

        filterCompleted(order) {
            return order.completed === (this.isCompleted ? 1 : 0)
        },

        filterOrderTypes(order) {
            return (
                this.filters.order_type_id == 0 ||
                order.order_type_id === this.filters.order_type_id
            )
        },
        filterRequestCategories(order) {
            return (
                this.filters.service_category == 0 ||
                order.request_category_id === this.filters.service_category
            )
        },

        filterDateRange(order) {
            const created_end = new Date(this.filters.created_end).getTime()
            const created_start = new Date(this.filters.created_start).getTime()
            const schedule_at = new Date(order.schedule_at).getTime()
            return (
                schedule_at > created_start - dayTime &&
                schedule_at < created_end + dayTime
            )
        },

        doSearch() {
            const $this = this
            const { filters } = this
            this.$nextTick(() => {
                $this.tableLoading = true
                $this.$store.dispatch('customerPortal/fetchOrders', {
                    filters,
                })
            })
        },

        calculateOrderPrice(order) {
            const orderItems = order.items
            let orderPrice = 0

            for (let item of orderItems) {
                const basePrice = parseFloat(item.price) * item.quantity
                const tax = basePrice * parseFloat(item.tax_rate)
                orderPrice += basePrice + tax
            }

            return orderPrice
        },
    },
}
</script>
